import { createFileRoute } from '@tanstack/react-router';
import { MembersSettingsPage } from '../components/settings/members-settings-page.js';

export const Route = createFileRoute('/$workspaceSlug/settings/members')({
  component: MembersSettingsPage,
});
